import React from "react"
import Clickable from "@components/clickable"
import classnames from "@utils/classnames"
import { AngleRight as Icon } from "@components/icon"
import styles from "./widget.module.scss"

const Widget = ({ title, image, info, className, children, ...props }) => (
  <Clickable className={classnames(styles.widget, className)} {...props}>
    <div
      className={styles.image}
      style={{
        backgroundImage: `url(${image})`,
      }}
    />
    <div className={styles.title}>
      <h3>{title}</h3>
      <p>{!info ? "查看详情" : info}</p>
    </div>
    <div className={styles.arrow}>
      <Icon />
    </div>
  </Clickable>
)

export default Widget
